<ng-container *transloco="let t; read: 'user'">
  <div class="p-5 mt-5">
    <div class="flex flex-row">
      <div class="basis-1/2">
        <drdp-title [title]="isScantron ? t('inputRating.common.inputRatingsTitle') : t('inputRating.detail.titleRatingRecord')"></drdp-title>
        @if (hasMeasures) {
          <div><a class="text-blue-700" *drdpCheckPermission="Permission.CreateRatingSpanish">{{ t('inputRating.detail.spanishVersion') }}</a></div>
        }
      </div>
      @if (hasMeasures && !isPilotEnrollment && (createRatings || viewRatings)) {
        <div class="basis-full">
          <div class="flex justify-end items-end">
            <a class="text-blue-700 py-2 px-4 cursor-pointer" (click)="toggleView()">
              {{ isScantron ? t('inputRating.detail.linkToRatingRecord') : t('inputRating.detail.linkToInputRatings') }}
            </a>
          </div>
        </div>
      }
    </div>

    <drdp-student-info [studentInfo]="studentInfo" (actionClicked)="onActionClick($event)" [canLock]="canLock"
    [hasMeasures]="hasMeasures" [isScantron]="isScantron" [isRatingDisabled]="isRatingDisabled" [isRatingViewRejected]="isRatingViewRejected"></drdp-student-info>

    @if (!hasMeasures) {
      <drdp-container additionClasses=" min-h-[2rem] mt-4 p-4">
        {{ t('inputRating.detail.noRatingView') }}
      </drdp-container>
    }


    @if (!isScantron) {
      <drdp-rating-card [studentDomains]="studentDomains" [studentInfo]="studentInfo"
      (actionClicked)="selectRatingModal($event)" (editClicked)="openTeacherSurvey($event)" (viewClicked)="viewTeacherSurvey($event)"
      [isRatingDisabled]="isRatingDisabled || !createRatings"></drdp-rating-card>
    }


    @if (isScantron) {
      <ng-container class="mt-4">
        <drdp-scantron [studentDomains]="studentDomains" [studentInfo]="studentInfo" [carReasons]="carReasons"
        [isKinder]="isKinder" (measureUpdated)="processMeasureUpdate($event)"  [isRatingDisabled]="isRatingDisabled || !createRatings"></drdp-scantron>
      </ng-container>
    }

  </div>
</ng-container>
